import React from 'react';
import { VoucherFormSection } from '../../Section';

import { MinimumTicketsAmount } from '../MinimumTicketsAmount';
import { MinimumValue } from '../ValueRule/MinimumValue';
import { MaximumValue } from '../ValueRule/MaximumValue';
import { DirectRide } from '../DirectRide';

interface VoucherFormTripsProps {
  template?: {
    hideMinimumTicketsAmount: boolean;
    hideMinimumValue: boolean;
    hideMaximumValue?: boolean;
  };
}

const VoucherFormTrips: React.FC<VoucherFormTripsProps> = ({ template }) => {
  return (
    <VoucherFormSection
      title='Trips'
      subtitle='For which trips the voucher can be used.'
      inputs={
        <>
          {!template?.hideMinimumTicketsAmount && <MinimumTicketsAmount />}
          {!template?.hideMinimumTicketsAmount && <MinimumValue />}
          {!template?.hideMaximumValue && <MaximumValue />}
          <DirectRide />
        </>
      }
    />
  );
};

export default VoucherFormTrips;
